import { createUseStyles } from 'react-jss';

export default createUseStyles({
  formGroup: {
    marginBottom: '40px',
    '@media(max-width: 900px)': {
      marginBottom: '30px',
    },
  },
  imageFormGroup: {
    marginBottom: '70px',
    '@media(max-width: 900px)': {
      marginBottom: '40px',
    },
  }
});
